import React, { PureComponent } from 'react';

import { DisplayComponent } from 'formlabs-web-components/BaseComponents';
import { Grid, Cell } from 'formlabs-web-components/Grid';

import CareersDepartment from './CareersDepartment.js';

const LocationTeamsList = DisplayComponent(
  class LocationTeamsList extends PureComponent {
    render() {
      return (
        <Grid direction="x">
          <Cell largeSize="24">
            <h1>Jobs located at {this.props.name}</h1>
          </Cell>
          {this.props.teams.map(team => {
            return (
              <CareersDepartment
                key={team.id}
                name={team.name}
                jobs={team.jobs}
              />
            );
          })}
        </Grid>
      );
    }
  }
);

export default LocationTeamsList;
